import qs from 'query-string'

import axios from 'settings/axios'
import { apiEndpoints } from 'settings/_apiSettings'

interface PatientSchedulesParams {
  patientUsername: string
  startDate: string
  endDate: string
  pagination: {
    page: number
    perPage: number
  }
  statusCodelist: string[]
}

interface PatientSchedulesResponse {
  schedules: {
    start_date: string
    end_date: string
  }[]
}

export async function getPatientSchedules({
  patientUsername,
  startDate,
  endDate,
  pagination,
  statusCodelist
}: PatientSchedulesParams): Promise<PatientSchedulesResponse> {
  const params = {
    page: pagination.page,
    per_page: pagination.perPage,
    start_date: startDate,
    end_date: endDate,
    status_code_list: statusCodelist
  }
  const { data } = await axios.get<PatientSchedulesResponse>(apiEndpoints.PATIENTS_SCHEDULES(patientUsername), { 
    params,
    paramsSerializer: (params) => qs?.stringify(params)
  })
  
  return data
}